import Photo1 from '../../images/f1_1.jpg';
import Photo2 from '../../images/f1_2.jpg';

type Props = {};

export default function Page3({}: Props) {
	return (
		<>
			<h1 className="text-5xl font-medium border-b-2 border-b-customBlue w-fit pb-2">F1</h1>
			<div className="flex gap-10 w-full items-center justify-center h-[500px]">
				<div className="h-full w-fit rounded-xl overflow-hidden">
					<img src={Photo1} className="h-full w-full object-contain" alt="img_f1" />
				</div>
				<div className="h-full w-fit rounded-xl overflow-hidden">
					<img src={Photo2} className="h-full w-full object-contain" alt="img_f1" />
				</div>
			</div>

			<div className="flex flex-col">
				<h3 className="text-3xl mb-3">Dostępne opcje (ten tydzień)</h3>
				<span className="text-xl">{'->'} Piątek 20:15, Blue City</span>
				<span className="text-xl">{'->'} Sobota 20:15, Blue City</span>
				<span className="text-xl">{'->'} Niedziela 20:15, Blue City</span>
			</div>
		</>
	);
}
